import React, { ReactElement } from 'react'

import LegacySeatSelection from '@pages/Checkout/SeatSelection/Legacy'
import NewSeatSelection from '@pages/Checkout/SeatSelection/New'
import { useSettings } from '@queries/settings'

export interface SeatSelectionProps {
  onSeatsError?: (error: ErrorCode | null) => void
  isLoading: boolean
}

const SeatSelection = (props: SeatSelectionProps): ReactElement => {
  const [{ seatSelection }] = useSettings()
  const Component = seatSelection.showSeatsPerSegmentOnCheckout ? NewSeatSelection : LegacySeatSelection

  return <Component {...props} />
}

export default SeatSelection
